"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const galleryImages = [{
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1670658/img/jewelry_cad_render_ring.png",
  alt: "Digital CAD render of a complex geometric diamond ring",
  aspect: "aspect-[4/5]"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1670658/img/gold_pendant.png",
  alt: "Beautiful gold pendant",
  aspect: "aspect-[16/9]"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1670658/img/platinum_finished_jewelry.png",
  alt: "Final polished platinum ring with intricate filigree",
  aspect: "aspect-[4/5]"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1670658/img/jewelry_3d_print_green_wax.png",
  alt: "Green resin 3D print of a custom engagement band",
  aspect: "aspect-[16/9]"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1670658/img/cad_wireframe_technical.png",
  alt: "Technical wireframe view of a multi-stone jewelry setting",
  aspect: "aspect-[4/5]"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1670658/img/gold_earrings.png",
  alt: "Beautiful gold earrings",
  aspect: "aspect-[16/9]"
}];
export default function FreshFromTheOven() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="223205" id="mastering-the-model" className="bg-background text-foreground py-24 px-6 md:px-12 lg:px-24 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <div className={`mb-16 md:mb-24 text-center transition-all duration-1000 transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-default font-bold mb-6 tracking-tighter text-primary">
            Mastering the Model
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto font-default text-xl md:text-2xl leading-relaxed">
            Bridging the gap between digital precision and physical craftsmanship through high-resolution CAD and wax prototyping.
          </p>
        </div>

        <div ref={ref} className={`columns-1 md:columns-2 lg:columns-3 gap-10 transition-all duration-1000 delay-200 transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {galleryImages.map((image, i) => <Link key={i} to="/PrecisionPortfolioPage" data-index={i} className="block break-inside-avoid mb-10 relative group overflow-hidden rounded-md bg-card/40 backdrop-blur-md border border-white/10 shadow-lg">
              <div className={`w-full ${image.aspect} relative overflow-hidden`}>
                <img src={image.src} alt={image.alt} className="w-full h-full object-cover transition-transform duration-1000 ease-out group-hover:scale-110" loading="lazy" />
                
                {}
                <div className="absolute inset-0 bg-background/60 backdrop-blur-sm opacity-0 group-hover:opacity-100 transition-opacity duration-500 flex flex-col items-center justify-center p-6">
                  <p className="font-mono text-[10px] text-secondary mb-4 opacity-0 group-hover:opacity-100 transition-opacity duration-700 delay-200 text-center uppercase tracking-widest">
                    {image.alt}
                  </p>
                  <Button variant="secondary" className="pointer-events-none opacity-0 translate-y-4 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-500 delay-100 uppercase tracking-widest text-xs font-semibold bg-secondary text-secondary-foreground hover:bg-secondary/90 rounded-md shadow-md">
                    Inspect Detail
                  </Button>
                </div>
              </div>
            </Link>)}
        </div>
      </div>
    </section>;
}